import { BehaviorSubject } from 'rxjs';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HttpLoadingService {
  public readonly isLoading: BehaviorSubject<boolean>;

  constructor() { 
    this.isLoading = new BehaviorSubject<boolean>(true);
  }
}
